const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Gmail attachment ids (e.g. ANGjdJ8…) — not upload handles. */
export function isGmailAttachmentId(id: string): boolean {
  const trimmed = id.trim();
  if (trimmed.length < 16) return false;
  if (UUID_RE.test(trimmed)) return false;
  return /^[A-Za-z0-9_-]+$/.test(trimmed);
}

export function isUploadAttachmentHandle(id: string): boolean {
  return UUID_RE.test(id.trim());
}

/**
 * Pick the smallest set of download URLs for an attachment id.
 * Avoids trying handle endpoints for Gmail ids (each miss shows as a 404 in DevTools).
 */
export function buildAttachmentDownloadCandidates(
  attachmentId: string,
  messageId?: string,
  threadId?: string,
): string[] {
  const encodedId = encodeURIComponent(attachmentId.trim());
  const candidates: string[] = [];

  if (isGmailAttachmentId(attachmentId)) {
    if (messageId) {
      candidates.push(
        `/api/email/messages/${messageId}/attachments/${encodedId}`,
        `/api/messages/email/${messageId}/attachments/${encodedId}`,
      );
    }
    if (threadId && threadId !== messageId) {
      candidates.push(`/api/messages/email/${threadId}/attachments/${encodedId}`);
    }
    return candidates;
  }

  if (isUploadAttachmentHandle(attachmentId)) {
    candidates.push(
      `/api/email/attachments/${encodedId}/download`,
      `/api/email/attachments/${encodedId}`,
    );
  }

  if (messageId) {
    candidates.push(
      `/api/email/messages/${messageId}/attachments/${encodedId}`,
      `/api/messages/email/${messageId}/attachments/${encodedId}`,
    );
  }

  if (threadId && threadId !== messageId) {
    candidates.push(`/api/messages/email/${threadId}/attachments/${encodedId}`);
  }

  if (!candidates.length) {
    candidates.push(
      `/api/email/attachments/${encodedId}/download`,
      `/api/email/attachments/${encodedId}`,
    );
  }

  return candidates;
}
